import { RequestStatus } from '../../utils';
import { CryptoCertificate, CryptoType } from '../types';

export interface CryptoState {
  items: CryptoCertificate[];
  status: RequestStatus;
  error: null | string;
  hasCertificates: boolean;
  cryptoType?: CryptoType;
}

export const initialState: CryptoState = {
  items: [],
  status: 'idle',
  error: null,
  hasCertificates: false,
  cryptoType: undefined,
};
